import axios, { AxiosError } from 'axios'
import axiosRetry from 'axios-retry'
import { Cookies } from 'react-cookie'

import httpTrialManager from './TrialManager'


const baseURL = import.meta.env.VITE_API_URL

const instance = axios.create({baseURL})
axiosRetry(instance, {retries: 3})

instance.interceptors.request.use(
  (req) => {
    httpTrialManager.addTry(req.url)

    const cookies = new Cookies()

    req.headers['access-token'] = cookies.get('accessToken')

    return req
  },
  (error) => {
    httpTrialManager.resetTry(error?.config?.url)
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  (res) => {
    httpTrialManager.resetTry(res.config.url)
    return res
  },
  (error) => {
    if (!(error instanceof AxiosError)) {
      return Promise.reject(error)
    }

    if (error?.response?.status === 401) {
      // 액세스 토큰이 만료되면 리프레쉬 토큰으로 재요청한다.
      if (
        error.response.data.message === 'ACCESS_TOKEN_EXPIRED' &&
        !httpTrialManager.isMax(error.config?.url)
      ) {
        const cookies = new Cookies()

        const originalReq = error.config

        if (originalReq) {
          originalReq.headers['access-token'] = ''
          originalReq.headers['refresh-token'] =
            cookies.get('refreshToken')

          console.log('✅ 액세스 없어서 재시도')

          return instance(originalReq)
        }
      }
    }

    if (error?.response?.status === 400) {
      console.error('❌ [ERR] 400 -> ' + error.response.data.message)
    }

    httpTrialManager.resetTry()
    return Promise.reject(error)
  }
)

export default instance
